var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLurganHorizontalVectorLurganLogoDubh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1168 288",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1035.69,66.15h77.56v155.7h-155.7V66.72l9.12,3.99,67.3,33.65,1.71.57v-38.78Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M414.62,66.44h122.05l9.12,2.28,6.84,3.42,5.7,4.56,4.56,4.56,4.56,7.41,2.85,8.55.57,3.99v7.98l-1.71,8.55-4.56,9.12-6.27,6.84-3.99,3.42-6.27,3.42-5.7,2.28-6.27,1.14h-3.99l30.23,60.45,5.7,10.84,2.85,6.27h-156.27V66.44Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M233.26,66.44h155.7v84.98l-1.71,10.84-2.85,9.7-4.56,9.7-5.7,8.55-7.41,8.55-6.84,6.27-9.12,6.27-9.12,4.56-9.7,3.42-8.55,1.71-5.7.57h-13.69l-11.41-1.71-9.7-2.85-11.98-5.7-7.98-5.7-7.98-6.84-5.7-6.27-5.13-7.41-5.7-10.84-3.42-10.27-1.71-10.27-.57-8.55v-76.99l.57-1.71Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.33,66.44h116.91v77.56h38.78v77.56H51.33V66.44Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M670.12,66.15h79.27l-.57,2.85-5.7,11.41-5.7,10.84-25.66,51.33-.57,1.71h38.78v76.99l-.57.57h-80.98l-10.84-1.14-9.7-2.28-9.12-3.42-8.55-4.56-6.27-4.56-7.98-6.84-6.27-6.84-6.84-10.27-4.56-9.7-2.85-9.7-1.71-11.41v-14.26l1.71-10.84,2.85-9.7,5.13-10.84,5.13-7.41,6.27-7.41,5.7-5.7,7.41-5.7,8.55-5.13,9.7-3.99,8.55-2.28,6.84-1.14,8.55-.57Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M853.19,66.44l1.71,1.71,45.62,91.25,5.7,10.84,25.09,50.19v1.14h-155.7l1.14-2.85,47.91-95.81,5.7-10.84,22.81-45.62Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLurganHorizontalVectorLurganLogoDubh);
export default __webpack_public_path__ + "static/media/Lurgan-Horizontal-Vector_Lurgan-Logo-Dubh.be125d9bf52fdd9fbf11c153fe44c389.svg";
export { ForwardRef as ReactComponent };